import mixins from 'vue-typed-mixins';

import { AppsMenuItem } from '@/interfaces/AppsMenuItem';
import { OverviewMenuItem } from '@/interfaces/OverviewMenuItem';
import axiosInstance from '@/services/axios';
import { eventBus } from '@/services/event-bus';
import apiUrls from '@/shared/api-urls';
import { constants } from '@/shared/constants';
import { getUrlOrSubscriber, getUrlParams } from '@/shared/helpers';
import routes from '@/shared/routes';

export const interactsNavigation = mixins().extend({
	data() {
		return {
			navigationItems: [] as OverviewMenuItem[],
			subscriberIdentity: '',
			appsNavigationItems: [] as AppsMenuItem[],
			digitalServices: constants.digitalServices,
			eventsTypes: constants.eventsTypes,
		};
	},
	created() {
		this.subscriberIdentity = getUrlParams().subscriberIdentity;
	},
	methods: {
		getNavigation(): Promise<void> {
			return axiosInstance.get(apiUrls.getNavigation.url)
				.then(({ data }) => {
					this.navigationItems = data;

					// for local testing
					if (~location.origin.indexOf('localhost'))
						this.navigationItems = JSON.parse(JSON.stringify(data).replaceAll(constants.devEnvUrl, 'https://localhost:8080'));

					const firstElementUrl = getUrlOrSubscriber(data);

					const pages = [ 'addService', ...constants.billsPages, ...constants.profilePages, ...constants.applicationPages, ...constants.supportPages ];
					if (!location.search && !routes.isSpecialPages(pages))
						(window as any).location = firstElementUrl;

					eventBus.$emit(this.eventsTypes.getOverviewNavigation, this.navigationItems);
				});
		},
		getAppsNavigation(): void {
			axiosInstance.get(apiUrls.getAppsNavigation.url)
				.then(({ data }) => {
					this.digitalServices.forEach((service: AppsMenuItem) => {
						service.active = this.addActiveParentField(service);
						service.visible =!!data.find((item: any) => item.name === service.title) || service.isConstant;
						service.images = data.find((item: any) => item.name === service.title)?.applications;
						service.subItems = (service.subItems || []).map((child: AppsMenuItem) => this.addActiveChildField(child));
					});
					this.appsNavigationItems = this.digitalServices;
					eventBus.$emit(this.eventsTypes.getAppsNavigation, this.appsNavigationItems);
				});
		},
		addActiveParentField(item: AppsMenuItem): boolean {
			const parentUrl = item.url ? item.url.toLowerCase() : '';
			const isChildActive = !!(item.subItems || []).find((child: AppsMenuItem) => this.isChildUrlActive(child));
			return parentUrl === this.getCurrentUrl() || isChildActive;
		},
		addActiveChildField(item: AppsMenuItem): AppsMenuItem {
			return { ...item, active: this.isChildUrlActive(item) };
		},
		isChildUrlActive(item: AppsMenuItem): boolean {
			const childUrl = item.url ? item.url.toLowerCase() : '';
			return childUrl === this.getCurrentUrl();
		},
		getCurrentUrl(): string {
			return (location.pathname + location?.search).toLowerCase();
		}
	}
});
